import React, { useState } from 'react';
import classnames from 'classnames';

type TrailingStopStep = {
  triggerPct: string,
  profitPct: string,
};

type Props = {
  defaultSteps: TrailingStopStep[],
  checkboxLabel: string,
  canEdit: boolean,
};

const TrailingStopFields: React.FC<Props> = ({
  defaultSteps,
  checkboxLabel,
  canEdit,
}) => {
  const [steps, setSteps] = useState<TrailingStopStep[]>(defaultSteps);
  const [isChecked, setIsChecked] = useState<boolean>(defaultSteps.length > 0);

  const STEP = 0.1;

  if (!canEdit) {
    return (
      <div className="form-text text-muted">
        トレーリングストップ設定中のポジションがあるため、設定変更できません。
      </div>
    );
  }

  return <>
    <div className="form-check">
      <label className="form-check-label">
        <input className="form-check-input" type="checkbox"
          checked={isChecked}
          onChange={_e => {
            if (!isChecked && steps.length === 0) {
              setSteps([{ triggerPct: '', profitPct: '' }]);
            }
            setIsChecked(!isChecked);
          }}
        />
        {checkboxLabel}
      </label>
    </div>

    {isChecked && steps.map((step, index) => {
      const hasTriggerPctDuplicate = steps.some((s, i) => {
        if (step.triggerPct === '' || step.profitPct === '') {
          return false;
        }
        return s.triggerPct === step.triggerPct && index !== i;
      });
      const isIncluded = steps.some((s, i) => {
        if (index === i) { return false; }
        if (step.triggerPct === '' || step.profitPct === '') {
          return false;
        }
        if (s.triggerPct === '' || s.profitPct === '') {
          return false;
        }
        return Number(s.triggerPct) >= Number(step.triggerPct) &&
               Number(step.profitPct) >= Number(s.profitPct);
      });

      return (
        <div key={index}>
          <div className="d-flex mb-1">
            <div className="input-group">
              <span className="input-group-text">含み益が</span>
              <input
                type="number"
                value={steps[index].triggerPct ?? ''}
                onChange={(e) => {
                  const newSteps = [...steps];
                  newSteps[index].triggerPct = e.target.value;
                  setSteps(newSteps);
                }}
                className={classnames(
                  'form-control',
                  hasTriggerPctDuplicate && 'is-invalid',
                )}
                required
                step={STEP}
                min={Number(step.profitPct) + STEP}
              />
              <span className="input-group-text">%に達したあと</span>
              <input
                type="number"
                value={steps[index].profitPct ?? ''}
                onChange={(e) => {
                  const newSteps = [...steps];
                  newSteps[index].profitPct = e.target.value;
                  setSteps(newSteps);
                }}
                className={classnames(
                  'form-control',
                  isIncluded && 'is-invalid',
                )}
                required
                step={STEP}
                min="0.0"
                max={Number(step.triggerPct) - STEP}
              />
              <span className="input-group-text">%に下がったら決済</span>
            </div>

            <button className="btn btn-outline-danger ms-2"
              type="button"
              onClick={() => {
                const newSteps = steps.filter((_, i) => i !== index);
                setSteps(newSteps);
              }}
            >
              <i className="fas fa-times"></i>
            </button>

            <input type="hidden" name={`trailing_stop_steps[${index}][trigger_pct]`} value={step.triggerPct} />
            <input type="hidden" name={`trailing_stop_steps[${index}][profit_pct]`} value={step.profitPct} />
          </div>
          {isIncluded && <span className="text-danger text-small mb-1">
            このステップは他のステップに含まれています。含まれないように修正してください。
          </span>}
        </div>
      );
    })}

    {isChecked && <button className="btn btn-outline-primary mt-1"
      type="button"
      onClick={() => {
        setSteps([...steps, { triggerPct: '', profitPct: '' }]);
      }}
    > <i className="fas fa-plus"></i>ステップを追加</button>}
  </>;
};

export default TrailingStopFields;
